import React from 'react'
import './Services-css/serviceseven.css'
const ServiceSeven = () => {
  return (
    <div className='service-seven-container'>
      <div className='service-seven serviceSeven-grid-system'>
        <div className='ser-seven-text'>
            Helping You Help Your Loved One        
        </div>
      </div>
      
      </div>
  )
}

export default ServiceSeven